import { render, staticRenderFns } from "./PersonalDemo.vue?vue&type=template&id=3f07a82e&"
import script from "./PersonalDemo.vue?vue&type=script&lang=js&"
export * from "./PersonalDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports